import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ICandidateFormInput, ICandidateUpdateProps } from "./Candidate.model";
import { candidateService } from "../../service/Candidate/candidate.service";
import CandidateForm from "./_candidateForm";
import { useContext } from "react";
import { MessageContext } from "../../context/MessageContext";

const CandidateUpdate = ({
  data,
  setCandidateDialog,
  loadCandidates,
}: ICandidateUpdateProps) => {
  const [id, setId] = useState<number | null>(null);
  const { pushMessageForToast } = useContext(MessageContext);

  const methods = useForm<ICandidateFormInput>({
    defaultValues: {
      name: "",
      email: "",
      gender: "",
      hobby: "",
      address: "",
      phone: "",
      topics: [],
      year_of_experience: null,
    },
  });

  useEffect(() => {
    if (data) {
      setId(data.id);
      methods.reset({
        name: data.name,
        email: data.email,
        gender: data.gender,
        hobby: data.hobby,
        address: data.address,
        phone: data.phone,
        topics: data.topics,
        year_of_experience: data.year_of_experience,
      });
    }
  }, [data]);

  const onSubmit = async (values: ICandidateFormInput) => {
    if (!id) return;

    const payload = { ...values, id };

    const response = await candidateService.update(id, payload);

    if (response.success) {
      loadCandidates?.();
      setCandidateDialog(false);
      pushMessageForToast({
        severity: "success",
        message: "Candidate updated successfully",
      });
    } else {
      pushMessageForToast({
        severity: "error",
        message: response?.errors?.detail || response?.errors?.message,
      });
      Object.keys(response.errors || {}).forEach((field) => {
        methods.setError(field as any, {
          type: "manual",
          message: response.errors[field],
        });
      });
    }
  };

  return <CandidateForm methods={methods} onSubmit={onSubmit} isEdit={true} />;
};

export default CandidateUpdate;
